// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/_containers/aside/aside';
import 'snippets/algolia-listing/algolia-listing';
import 'sections/hero/hero';
import 'sections/main-collection/main-collection';
import 'sections/collection-list/collection-list-category-driver';
import 'sections/footer/footer';